export default __webpack_public_path__ + "static/media/betting-icon.54613b63.svg";